import { render, staticRenderFns } from "./app.vue?vue&type=template&id=4d2c544c&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=4d2c544c&prod&lang=scss&"
import style1 from "./app.vue?vue&type=style&index=1&id=4d2c544c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c544c",
  null
  
)

export default component.exports